import {Application} from '@app/views/admin/application-settings/models/application.model';
import {InstitutionsVendorListModel} from '@app/core/model/institutional-model';

export enum SignificantChangesReportAction {
    APPLIED = 'APPLIED',
    REJECTED  = 'REJECTED',
    AUTO_APPLIED = 'AUTO_APPLIED',
    AUTO_REJECTED  = 'AUTO_REJECTED',
}

export enum SignificantChangesActionType {
    UPDATES = 'UPDATES',
    INSERT = 'INSERT',
    DELETES  = 'DELETES'
}

export enum SignificantChangesType {
    SIGNIFICANT = 'SIGNIFICANT',
    ENORMOUS  = 'ENORMOUS'
}

export enum SignificantChangesReportedFrom {
    PROCESSING = 'PROCESSING',
    PREVIEW_MODE  = 'PREVIEW_MODE',
    ACTIVE_INTEGRATION_STATE_ACCESS  = 'ACTIVE_INTEGRATION_STATE_ACCESS',
    VALIDATION_OR_FILTRATION_ACCESS = 'VALIDATION_OR_FILTRATION_ACCESS'
}

export const SUPPORT_ACTOR_ID = 'Support_actor_ID';

export class SignificantChangesReport {
    reportId: string;
    districtGuid: string;
    sessionId: number;
    currentIntegrationId: string;
    reportCreatedTimestamp: Date;
    reportedFrom: SignificantChangesReportedFrom;
    finalAppliedAction: SignificantChangesReportAction;
    finalAppliedActionTimestamp: Date;
    decisions: SignificantChangesDecision[];
    stats: SignificantChangesStat[];
    isCurrentUserCanApplyChanges?: boolean;

    constructor() {

    }

    public checkIsCurrentUserCanApplyChanges(actorId: string): boolean {
        this.isCurrentUserCanApplyChanges = !this.finalAppliedAction &&
            this.decisions &&
            this.decisions.some((decision: SignificantChangesDecision) =>
                decision && !decision.appliedAction && decision.actorId == actorId
            );

        return this.isCurrentUserCanApplyChanges;
    }
}

export class SignificantChangesDecision {
    reportRef: string;
    districtGuid: string;
    actorId: string;
    sessionId: number;
    appliedAction: SignificantChangesReportAction;
    appliedActionTimestamp: Date;
    appliedActionUserId: string;
    appliedActionOrgGuid: string;
    changesType: string;
    actorName?: string;
}

export class SignificantChangesStat {
    districtGuid: string;
    integrationId: string;
    sessionId: number;
    applicationGuid: string;
    changesType: SignificantChangesType;
    entityType: string;
    changesPercent: string;
    affectedCount: number;
    changesActionType: SignificantChangesActionType;
    reportTimestamp: Date;
    reportRef: string;
}

export class SignificantChangeLoadingConfig {
    orgGuid: string;
    offset: number;
    limit: number;
    lastReportSessionId: number;
    isAllSignificantChangesLoaded: boolean;

    constructor(orgGuid: string,
        offset: number,
        limit: number,
        lastReportSessionId: number,
        isAllSignificantChangesLoaded: boolean
    ) {
        this.orgGuid = orgGuid;
        this.offset = offset;
        this.limit = limit;
        this.lastReportSessionId = lastReportSessionId;
        this.isAllSignificantChangesLoaded = isAllSignificantChangesLoaded;
    }
}

export class SignificantChangesIntegrationStats {
    decision: SignificantChangesDecision;
    updatedEntitiesStats: SignificantChangesStat[];
    deletedEntitiesStats: SignificantChangesStat[];
    application: Application;
    institution: InstitutionsVendorListModel;

    constructor() {
        this.updatedEntitiesStats = [];
        this.deletedEntitiesStats = [];
    }
}
